import axios from 'axios';
import {baseURL} from '../Constants';

const url = `${baseURL}user/`;

export function loginUser(user) {
  return axios
    .get(`${url}?username=${user.userName}&password=${user.password}`)
    .then((response) => response)
    .catch((response) => response);
}


// WEBPACK FOOTER //
// ./src/login/loginApi.js